
  <div class="detailedMarunageForm">    
    <div class="ui warning message" v-if="form.hasErrors()">
      <ul class="list">
        <li v-if="form.hasError('prefecture')">都道府県を選択してください</li>
        <li v-if="form.hasError('area')">エリアを選択してください</li>
        <li v-if="form.hasError('area_detail')">エリア詳細を選択してください</li>
        <li v-if="form.hasError('purpose')">利用主旨を入力してください</li>
        <li v-if="form.hasError('event_date')">利用日を選択してください</li>
        <li v-if="form.hasError('event_time')">開始時間を選択してください</li>
        <li v-if="form.hasError('people')">人数を選択してください</li>
        <li v-if="form.hasError('is_event_datetime_flexible')">日時の変更可否を入力してください</li>
        <li v-if="form.hasError('price')">一人あたりの予算を選択してください</li>
        <li v-if="form.hasError('is_price_flexible')">予算の変更可否を入力してください</li>
        <li v-if="form.hasError('is_company')">会社・団体/個人の区分を入力してください</li>
        <li v-if="form.hasError('company_name')">会社名・団体名を入力してください</li>
        <li v-if="form.hasError('name')">名前を入力してください</li>
        <li v-if="form.hasError('tel')">電話番号を正しく入力してください</li>
        <li v-if="form.hasError('email')">メールアドレスを正しく入力してください</li>
        <li v-if="form.hasError('agree_terms')">利用規約に同意してください</li>
      </ul>
    </div>
    <div class="ui form">
      <h3 class="detailedMarunageForm__contentTitle">お問い合わせ内容入力</h3>
      <div class="detailedMarunageForm__formWrap">
        <div v-if="!form.model.shop_id">
          <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('prefecture')}">
            <div class="detailedMarunageForm__label">
              <div class="required_icon">必須</div>
              <label>都道府県</label>
            </div>
          <dropdown v-model="form.model.prefecture" @change="onPrefectureChange()" id="prefecture" :name="`${formNamePrefix}prefecture`" placeholder="都道府県">
            <option v-for="each in consts.MARUNAGE_SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">
              {{ each.label }}
            </option>
          </dropdown>
          </div>
          <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('area')}">
            <div class="detailedMarunageForm__label">
              <div class="required_icon">必須</div>
              <label>エリア</label>
            </div>
            <dropdown v-model="form.model.area" @change="onAreaChange()" id="area" :name="`${formNamePrefix}area`">
              <option v-for="each in this.areaOptions" :key="each.label" :value="each.value" :disabled="each.value === ''">
                {{ each.label }}
              </option>
            </dropdown>
          </div>
          <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('area_detail')}">
            <div class="detailedMarunageForm__label">
              <div class="required_icon">必須</div>
              <label>エリア詳細</label>
            </div>
            <dropdown ref="areaDetail" v-model="form.model.area_detail" id="area_detail" :name="`${formNamePrefix}area_detail`">
              <option value="">エリア詳細</option>
            </dropdown>
          </div>
        </div>
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('category')}">
            <div class="detailedMarunageForm__label">
              <div class="required_icon">必須</div>
              <label>利用カテゴリ</label>
            </div>
            <dropdown v-model="form.model.category" :options="consts.MARUNAGE_CATEGORY" id="category" :name="`${formNamePrefix}category`"></dropdown>
          </div>
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('purpose')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>利用主旨</label>
          </div>
          <input type="text" v-model="form.model.purpose" :placeholder="'例) 会社の創業10周年記念パーティー'" id="purpose" :name="`${formNamePrefix}purpose`" />
        </div>
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('event_date')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>利用日</label>
          </div>
          <div class="detailedMarunageForm__item" :class="{'error': form.hasError('event_date')}">
            <datepick v-model="form.model.event_date" :from="3" id="event_date" :name="`${formNamePrefix}event_date`"></datepick>
          </div>
        </div>
        <div class="detailedMarunageForm__twoColSp">
          <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('event_time')}">
            <div class="detailedMarunageForm__label">
              <div class="required_icon">必須</div>
              <label>開始時間</label>
            </div>
            <dropdown v-model="form.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" id="event_time" :name="`${formNamePrefix}event_time`"></dropdown>
          </div>
          <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('people')}">
            <div class="detailedMarunageForm__label">
              <div class="required_icon">必須</div>
              <label>人数</label>
            </div>
            <dropdown v-model="form.model.people" :options="consts.MARUNAGE_PEOPLE" id="people" :name="`${formNamePrefix}people`"></dropdown>
          </div>
        </div>
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('is_event_datatime_flexible')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>日時の変更可否</label>
          </div>
          <div class="detailedMarunageForm__choice">
            <input type="radio" v-model="form.model.is_event_datatime_flexible" id="is_event_datatime_flexible_yes" :name="`${formNamePrefix}is_event_datatime_flexible`" :value=true /><label for="is_event_datatime_flexible_yes">変更可</label>
            <input type="radio" v-model="form.model.is_event_datatime_flexible" id="is_event_datatime_flexible_no" :name="`${formNamePrefix}is_event_datatime_flexible`" :value=false /><label for="is_event_datatime_flexible_no">変更不可</label>
            <div class="detailedMarunageForm__choice__text">
              <small>※人気の日程は埋まっているケースも多いため、調整可能な日程のご入力を推奨します。</small>
            </div>
            <input v-if="form.model.is_event_datatime_flexible" type="text" v-model="form.model.event_datetime_memo" :placeholder="'例) 12月の金曜日なら調整可能です。'" id="event_datetime_memo" :name="`${formNamePrefix}event_datetime_memo`" />
          </div>
        </div>
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('price')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>1人あたりの予算</label>
          </div>
          <dropdown v-model="form.model.price" :options="consts.MARUNAGE_PRICE" id="price" :name="`${formNamePrefix}price`"></dropdown>
        </div>
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('is_price_flexible')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>予算の変更可否</label>
          </div>
          <div class="detailedMarunageForm__choice">
            <input type="radio" v-model="form.model.is_price_flexible" id="is_price_flexible_yes" :name="`${formNamePrefix}is_price_flexible`" :value=true /><label for="is_price_flexible_yes">変更可</label>
            <input type="radio" v-model="form.model.is_price_flexible" id="is_price_flexible_no" :name="`${formNamePrefix}is_price_flexible`" :value=false /><label for="is_price_flexible_no">変更不可</label>
            <input v-if="form.model.is_price_flexible" type="text" v-model="form.model.price_memo" :placeholder="'例) 予算最大1万円まで調整可能。'" id="price_memo" :name="`${formNamePrefix}price_memo`" />
          </div>
        </div>
        <div class="detailedMarunageForm__twoColSp">
          <div class="fields detailedMarunageForm__row">
            <div class="detailedMarunageForm__label">
              <label>立食・着席希望</label>
            </div>
            <dropdown v-model="form.model.seat_preference" :options="consts.MARUNAGE_SEAT_PREFERENCE" id="seat_preference" :name="`${formNamePrefix}seat_preference`"></dropdown>
          </div>
          <div class="fields detailedMarunageForm__row">
            <div class="detailedMarunageForm__label">
              <label>会議室のご利用</label>
            </div>
            <dropdown v-model="form.model.use_meeting_room" :options="consts.MARUNAGE_MEETING_ROOM" id="use_meeting_room" :name="`${formNamePrefix}use_meeting_room`"></dropdown>
          </div>
        </div>
        <div class="fields detailedMarunageForm__row">
          <div class="detailedMarunageForm__label">
            <label>設備・サービス</label>
          </div>
          <div class="detailedMarunageForm__choice">
            <checkbox-group v-model="form.model.use_facilities" :options="consts.MARUNAGE_FACILITY"></checkbox-group>
            <input type="text" v-model="form.model.use_facilities_memo" :placeholder="'例) くす玉を用意してほしい'" id="use_facilities_memo" :name="`${formNamePrefix}use_facilities_memo`" />
          </div>
        </div>
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('note')}">
          <div class="detailedMarunageForm__label">
            <label>その他希望条件</label>
          </div>
          <textarea rows="4" v-model="form.model.note" placeholder="例）楽器の演奏は可能でしょうか？" id="note" :name="`${formNamePrefix}note`"></textarea>
        </div>
      </div>
      <h3 class="detailedMarunageForm__contentTitle">お客様情報入力</h3>
      <div class="detailedMarunageForm__formWrap">
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('is_company')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>会社・団体 / 個人</label>
          </div>
          <div class="detailedMarunageForm__choice">
            <input type="radio" v-model="form.model.is_company" id="is_company_yes" :name="`${formNamePrefix}is_company`" :value=true /><label for="is_company_yes">会社・団体</label>
            <input type="radio" v-model="form.model.is_company" id="is_company_no" :name="`${formNamePrefix}is_company`" :value=false /><label for="is_company_no">個人</label>
          </div>
        </div>
        <div v-if="form.model.is_company" class="fields detailedMarunageForm__row" :class="{'error': form.hasError('company_name')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>会社名・団体名</label>
          </div>
          <input type="text" v-model="form.model.company_name" :placeholder="'例) 株式会社グルメプラス'" id="company_name" :name="`${formNamePrefix}company_name`" />
        </div>          
        <div class="fields detailedMarunageForm__row" :class="{'error': form.hasError('name')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>名前</label>
          </div>
          <input type="text" v-model="form.model.name" :placeholder="'例) 田中太郎'" id="name" :name="`${formNamePrefix}name`" />
        </div>
        <div v-if="!userId" class="fields detailedMarunageForm__row" :class="{'error': form.hasError('email')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>メールアドレス</label>
          </div>
          <input type="text" v-model="form.model.email" :placeholder="'例) info@example.com'" id="email" :name="`${formNamePrefix}email`" />
        </div>
        <div v-if="!hasTel" class="fields detailedMarunageForm__row" :class="{'error': form.hasError('tel')}">
          <div class="detailedMarunageForm__label">
            <div class="required_icon">必須</div>
            <label>電話番号</label>
          </div>
          <input type="text" v-model="form.model.tel" :placeholder="'例) 08012345678'" id="tel" :name="`${formNamePrefix}tel`" />
        </div>
        <div class="fields detailedMarunageForm__row">
          <div class="detailedMarunageForm__label">
            <label>特典・お知らせ</label>
          </div>
          <div class="detailedMarunageForm__choice">
            <input type="radio" v-model="form.model.accept_notifications" id="accept_notifications_yes" :name="`${formNamePrefix}accept_notifications`" :value=true /><label for="accept_notifications_yes">受け取る</label>
            <input type="radio" v-model="form.model.accept_notifications" id="accept_notifications_no" :name="`${formNamePrefix}accept_notifications`" :value=false /><label for="accept_notifications_no">受け取らない</label>
            <br><div class="notice">※Amazonギフトの受け取りに必要です。</div>
          </div>
        </div>

        <div class="detailedMarunageForm__bottomCheckbox">
          <div class="ui checkbox"><input type="checkbox" v-model="form.model.accept_marunage_candidate" id="accept_marunage_candidate" :name="`${formNamePrefix}accept_marunage_candidate`" /><label>近隣会場の提案も検討したい</label></div>
          <checkbox v-model="form.model.agree_terms" :class="{'error': form.hasError('agree_terms')}" id="agree_terms" :name="'agree_terms'"><a href="/term/" target="_blank">利用規約</a>に同意する</checkbox>
        </div>
      
      </div>
      <app-message :msg="form.appMessage"></app-message>
      <div class="field">
        <button @click="marunage" class="ui fluid orange button large detailedMarunageForm__btn" :class="{'disabled loading': form.waiting, 'disabled': !isFormComplete}">{{ isFormComplete ? actionLabel : '未入力の項目があります' }}</button>
      </div>
    </div>
</div>
  